import { module } from 'modujs';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default class extends module {
    init() {
        const slider = this.el.querySelector('.swiper');

        if (!slider) return;

        this.swiper = new Swiper(slider, {
            modules: [Navigation],
            slidesPerView: 1.08,
            spaceBetween: 12,
            watchOverflow: true,
            navigation: {
                nextEl: this.el.querySelector('.m-cards-list_nav.-next'),
                prevEl: this.el.querySelector('.m-cards-list_nav.-prev'),
            },
            breakpoints: {
                701: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1001: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
            },
        });
    }

    destroy() {
        this.swiper?.destroy(true, true);
    }
}
